import { createAction } from '@reduxjs/toolkit';

export const contactUpdateId = createAction('contact/updateId');
export const contactUpdateUID = createAction('contact/updateUID');
export const contactUpdateSID = createAction('contact/updateSID');
export const contactUpdateIsAdded = createAction('contact/updateIsAdded');
export const contactUpdateIsActive = createAction('contact/updateIsActive');

export const contactStore = createAction('contact/store');
export const contactClear = createAction('contact/clear');

export const contactUpdateRequest = createAction('contact/updateRequest');
export const contactUpdateError = createAction('contact/updateError');
export const contactUpdateStore = createAction('contact/updateStore');

export const contactUpdateItems = createAction('contact/updateItems');

export const contactUpdateLayout = createAction('contact/updateLayout');
export const contactUpdateView = createAction('contact/updateView');

export const contactUpdateButtonTitle = createAction('contact/updateButtonTitle');
export const contactUpdateButtonBackgroundColor = createAction('contact/updateButtonBackgroundColor');
export const contactUpdateButtonTextColor = createAction('contact/updateButtonTextColor');
export const contactUpdateButtonOpacity = createAction('contact/updateButtonOpacity');
export const contactUpdateButtonBorder = createAction('contact/updateButtonBorder');
export const contactUpdateButtonBorderColor = createAction('contact/updateButtonBorderColor');
export const contactUpdateButtonShadow = createAction('contact/updateButtonShadow');
export const contactUpdateButtonShadowColor = createAction('contact/updateButtonShadowColor');
export const contactUpdateButtonShape = createAction('contact/updateButtonShape');

export const contactUpdateHeadingTitle = createAction('contact/updateHeadingTitle');
export const contactUpdateHeadingDescription = createAction('contact/updateHeadingDescription');
export const contactUpdateHeadingTextAlign = createAction('contact/updateHeadingTextAlign');
export const contactUpdateHeadingImage = createAction('contact/updateHeadingImage');
export const contactUpdateHeadingDivider = createAction('contact/updateHeadingDivider');

export const contactUpdateSectionIsBackground = createAction('contact/updateSectionIsBackground');
export const contactUpdateSectionTextColor = createAction('contact/updateSectionTextColor');
export const contactUpdateSectionBackgroundColor = createAction('contact/updateSectionBackgroundColor');
export const contactUpdateSectionOpacity = createAction('contact/updateSectionOpacity');
export const contactUpdateSectionIsFullWidth = createAction('contact/updateSectionIsFullWidth');
export const contactUpdateSectionShadow = createAction('contact/updateSectionShadow');
export const contactUpdateSectionShadowColor = createAction('contact/updateSectionShadowColor');
export const contactUpdateSectionPadding = createAction('contact/updateSectionPadding');
export const contactUpdateSectionMargin = createAction('contact/updateSectionMargin');
export const contactUpdateSectionBackgroundType = createAction('contact/updateSectionBackgroundType');
export const contactUpdateSectionBackgroundImage = createAction('contact/updateSectionBackgroundImage');
export const contactUpdateSectionGradientColor1 = createAction('contact/updateSectionGradientColor1');
export const contactUpdateSectionGradientColor2 = createAction('contact/updateSectionGradientColor2');
export const contactUpdateSectionGradientDirection = createAction('contact/updateSectionGradientDirection');
export const contactUpdateSectionGradientOffset = createAction('contact/updateSectionGradientOffset');
export const contactUpdateSectionBorder = createAction('contact/updateSectionBorder');
export const contactUpdateSectionBorderColor = createAction('contact/updateSectionBorderColor');
export const contactUpdateSectionShadowBorderColor = createAction('contact/updateSectionShadowBorderColor');
export const contactUpdateSectionShape = createAction('contact/updateSectionShape');

export const contactUpdateItemOpacity = createAction('contact/updateItemOpacity');
export const contactUpdateItemShadow = createAction('contact/updateItemShadow');
export const contactUpdateItemShadowColor = createAction('contact/updateItemShadowColor');
export const contactUpdateItemBorder = createAction('contact/updateItemBorder');
export const contactUpdateItemBorderColor = createAction('contact/updateItemBorderColor');
export const contactUpdateItemShape = createAction('contact/updateItemShape');
